























































































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import Api from '@/api/order/orderLogs/index'
import { FormItem } from '../../types/iview/form'
@Component({
  components: {
    CustomForm,
  },
})
export default class CommissionList extends AbpBase {
  filters = [
    // {
    //   label: '分销员编号',
    //   type: 'input',
    //   props: {
    //     placeholder: '请输入分销员编号'
    //   },
    //   key: 'tradeNo'
    // }
    {
      label: '开始时间',
      type: 'date',
      props: {
        placeholder: '请选择开始日期',
      },
      key: 'startTime',
    },
    {
      label: '结束时间',
      type: 'date',
      props: {
        placeholder: '请选择结束日期',
      },
      key: 'endTime',
    },
  ]
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '姓名',
      slot: 'name',
      width: 100,
      align: 'center',
    },
    {
      title: '导购编码',
      slot: 'employeeCode',
      width: 140,
      align: 'center',
    },
    {
      title: '身份证号码',
      slot: 'idCard',
      width: 140,
      align: 'center',
    },
    {
      title: '手机号',
      slot: 'phoneNumber',
      width: 140,
      align: 'center',
    },
    {
      title: '职位',
      slot: 'position',
      width: 100,
      align: 'center',
    },
    {
      title: '所属办事处',
      slot: 'department',
      width: 160,
      align: 'center',
    },
    {
      title: '店铺编码',
      slot: 'shopCode',
      width: 100,
      align: 'center',
    },
    {
      title: '分销核算',
      slot: 'levelTypeStr',
      width: 100,
      align: 'center',
    },
    {
      title: '商品代码',
      slot: 'productCode',
      width: 100,
      align: 'center',
    },
    {
      title: '规格代码',
      slot: 'skuCode',
      width: 150,
      align: 'center',
    },
    {
      title: '规格名称',
      slot: 'skuName',
      width: 200,
      align: 'center',
    },
    {
      title: '销售数量',
      slot: 'count',
      width: 100,
      align: 'center',
    },
    {
      title: '销售单价',
      slot: 'promotionPrice',
      width: 100,
      align: 'center',
    },
    {
      title: '销售金额',
      slot: 'salesAmount',
      width: 100,
      align: 'center',
    },
    {
      title: '分佣比例',
      slot: 'percent',
      width: 100,
      align: 'center',
    },
    {
      title: '订单金额',
      key: 'orderAmount',
      width: 100,
      align: 'center',
    },
    {
      title: '收益明细',
      slot: 'income',
      width: 100,
      align: 'center',
    },
    {
      title: '收益金额',
      key: 'totalIncome',
      width: 100,
      align: 'center',
    },
    {
      title: '订单号',
      key: 'orderNo',
      width: 200,
      align: 'center',
    },
    {
      title: '收益状态',
      slot: 'incomeStatusStr',
      width: 100,
      align: 'center',
    },
  ]
  exporting: boolean = false
  copyData = []
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  mounted() {
    this.loadData()
  }
  submitChange(form, valid) {
    if (valid) {
      console.log(form)
      this.loadData(form)
    }
  }
  loadData(form = {}) {
    let startTime = form['startTime'] ? this.dateString(form['startTime']) : null
    let endTime = form['endTime'] ? this.dateString(form['endTime']) : null
    Api.commissionList(startTime, endTime, this.pager.pageSize, this.pager.pageIndex).then((res) => {
      this.pager.total = res.data.totalCount
      this.copyData = this._integratedData(res.data.items)
      // console.log('佣金统计列表', res)
    })
  }
  // 表格合并
  handleSpan({ row, column, rowIndex, columnIndex }) {
    if (columnIndex == 16 || columnIndex == 18 || columnIndex == 19) {
      return {
        rowspan: row.mergeCol === 0 ? 0 : row.mergeCol,
        colspan: row.mergeCol === 0 ? 0 : 1,
      }
    }
  }
  // 处理数据
  _integratedData(data) {
    var lastArr = []
    data.forEach((item, firstIndex) => {
      item.brokerageReportItems.forEach((innerItem, attrIndex) => {
        lastArr.push(
          Object.assign({}, item, {
            mergeCol: attrIndex === 0 ? item.brokerageReportItems.length : 0,
            listInfo: innerItem,
          })
        )
      })
    })
    console.log('处理后的佣金统计表数据', lastArr)
    return lastArr
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData((this.$refs.lineForm as any).form)
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  /**
   * 导出excel表格
   */
  exportExcel() {
    this.exporting = true
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    let startTime = form['startTime']
    let endTime = form['endTime']
    Api.exportBrokerageReportFile(this.pager.pageSize, this.pager.pageIndex, startTime, endTime)
      .then((res) => {
        console.log(res)
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  // 异步导出Excel
  exportExcelSync() {
    this.exporting = true
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    let startTime = form['startTime']
    let endTime = form['endTime']
    Api.exportExcelSync(this.pager.pageSize, this.pager.pageIndex, startTime, endTime)
      .then((res) => {
        console.log(res)
        this.exporting = false
        this.$router.push({
          name: 'exportExcelRecord',
        })
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '佣金统计表.xlsx')

    document.body.appendChild(link)
    link.click()
  }
  // distributorDetailFn(row) {
  //   console.log(row);
  //   this.$router.push({
  //     name: 'commissionListDetail',
  //     query: {
  //       userId: row.userId
  //     }
  //   })
  // }
}
